export default "__VITE_ASSET__CfpwAp9z__"